import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';

interface DialogData {
  message: string;
}

@Component({
    selector: 'success-modal',
    templateUrl: './success-modal.component.html',
    styleUrls: ['./success-modal.component.css'],
    standalone: false
})
export class SuccessModalComponent implements OnInit {

  constructor(@Inject(MAT_DIALOG_DATA) public data: DialogData) { }

  ngOnInit() {
  }

}
